// @ts-ignore
import React, { useCallback } from "react";
import { 
    gql, 
    useQuery 
} from "@apollo/client";
import { 
    FindOffersEndingSoonQueryQuery,
    FindOffersEndingSoonQueryQueryVariables,
    Offer 
} from "../../../schemaTypes";
import { newOfferSubscription } from "../FindOffers";

export const findOffersEndingSoonQuery = gql`
  query FindOffersEndingSoonQuery(
    $offset: Int!
    $limit: Int!
    $locationId: String!
  ) {
    findOffersEndingSoon(
      offset: $offset, 
      limit: $limit,
      locationId: $locationId
    ) {
      id
      title
      description
      bannerUrl
      # category {
      #   id
      #   name
      #   imgSrc
      #   createdAt
      #   # updatedAt
      # }
      offerType
      status
      # discountType
      # discountValue
      # partnerVoucher
      # referralUrl
      offerTOR
      startDate
      endDate
      # community{
      #   id
      #   name
      #   alias
      # }
      # location{
      #   id
      #   city
      # }
      createdBy{
        id
        admin {
          id
          merchantProfile {
            id
            # address
            # city
            # country
            # postcode
            companyName
            username
            # industry {
            #   id
            #   name
            # }
            companyLocation
            logoUrl
            bannerUrl
            description
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`;

newOfferSubscription;

export interface WithFindOffersEndingSoon{
  offers: Offer[];
  loading: boolean;
  loadMore: () => void;
  hasMoreOffers: boolean;
  subscribe: () => void;
}

interface Props {
  variables:   FindOffersEndingSoonQueryQueryVariables;
  children: (data: WithFindOffersEndingSoon) => React.ReactElement | null;
}

export const FindOffersEndingSoonController: React.FC<Props> = ({ children, variables }) => {
  const { data, loading, fetchMore, subscribeToMore } = useQuery<
    FindOffersEndingSoonQueryQuery,
    FindOffersEndingSoonQueryQueryVariables
  >(findOffersEndingSoonQuery, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  let offers: Offer[] = [];
  if (data && data.findOffersEndingSoon) {
    offers = data.findOffersEndingSoon as Offer[];
  }

  let hasMoreOffers = offers.length % variables.limit === 0;
  if (offers.length <= variables.offset) {
    hasMoreOffers = false;
  }

  const loadMore = useCallback(() => {
    fetchMore({
      variables: {
        ...variables,
        offset: offers.length
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return prev;
        }
        return {
          ...prev,
          findOffersEndingSoon: [
            ...prev.findOffersEndingSoon,
            ...fetchMoreResult.findOffersEndingSoon
          ]
        };
      }
    });
  }, [fetchMore, variables, offers.length]);

  // Subscription for new offers
  const subscribe = useCallback(() => {
    subscribeToMore({
      document: newOfferSubscription,
      variables: { variables },
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) {
          return prev;
        }
        return {
          ...prev,
          findOffersEndingSoon: [
            ...prev.findOffersEndingSoon,
            (subscriptionData.data as any).newOffer
          ]
        };
      }
    });
  }, [subscribeToMore, variables]);

  return children({
    hasMoreOffers,
    offers,
    loading,
    loadMore,
    subscribe,
  });
};